<template>
    <v-tooltip v-if="date"
               left>
      <template v-slot:activator="{on, attrs}">
        <div v-bind="attrs"
             v-on="on"
             class="text-nowrap">
          {{ date | datetime(shortFormat) }}
        </div>
      </template>
      <div>
        {{ date | datetime(longFormat) }}
      </div>
    </v-tooltip>
</template>
<script>
export default {
  props: {
    date: {
      type: String,
      required: false,
    },
    shortFormat: {
      type: String,
      default: 'MMM D, YYYY',
    },
    longFormat: {
      type: String,
      default: 'YYYY-MM-DD h:mm a',
    },
  }
}
</script>
